<template>
    <div>
        <h1>ESTADO</h1>

        <div>
            <p> estado do pedido - {{ state.estado }} </p>
        </div>
    </div>
</template>
    
<script>

export default {
    name: 'estado',
    components: {

    },
    data() {
        return {
            state: null,
        }
    },
    methods: {

        fetchState() {
            this.state = null;

            const actoState = {
                estado: 'Rejeitado',
            };

            this.state = actoState;

            // try {
            //     const response = await axios.get(`app/----/----`);

            //     // Extract data from the response
            //     if (response.status === 200 && response.data.data) {
            //         // Convert the object response to an array of values
            //         this.state = response.data.data;
            //     } else {
            //         console.error("Failed to fetch data:", response);
            //     }
            // } catch (error) {
            //     console.error("Error fetching data:", error);
            // }
        },
    },

    created() {
        this.fetchState();
    },
};
</script>